function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M183 62h24v64h-24zM183 266h24v64h-24zM274 179h64v24h-64zM297.9 106.1l-16.6-16.6-45.2 45.3 16.6 16.7zM95.1 109.1l45.2 45.4 16.6-16.7-45.2-45.3zM92.1 279.1l16.6 16.7 45.2-45.3-16.6-16.7zM58 179h64v24H58z"
});

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M192.2 153.4l-34 34.2 43.4 43.5 34.1-34.1zM447 408.8L251.7 213l-34.1 34.1L413 443z"
}));

function SvgIosColorWand({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref, _ref2);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIosColorWand);
export default __webpack_public_path__ + "static/media/ios-color-wand.d1d32c4d.svg";
export { ForwardRef as ReactComponent };